import generateCalendar, { CalendarProps } from 'antd/lib/calendar/generateCalendar';
import 'antd/lib/date-picker/style';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';

const Calendar = generateCalendar<Date>(dateFnsGenerateConfig);

export default Calendar;

export type { CalendarProps };
